module.exports = __webpack_public_path__ + "static/media/img-112.89bb708e.png";